var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass:
        "p0 inline-flex middle-xs bg-cl-transparent brdr-none action h5 pointer cl-secondary",
      attrs: { type: "button", "data-testid": "addToWishlist" },
      on: {
        click: function($event) {
          _vm.isOnWishlist
            ? _vm.removeProductFromWhishList(_vm.product)
            : _vm.addProductToWhishlist(_vm.product)
        }
      }
    },
    [
      _vm._t("default", [
        _c("i", { staticClass: "pr5 material-icons" }, [
          _vm._v(_vm._s(_vm.favoriteIcon))
        ]),
        _vm._v(" "),
        !_vm.isOnWishlist
          ? [_vm._v("\n      " + _vm._s(_vm.$t("Add to favorite")) + "\n    ")]
          : [_vm._v("\n      " + _vm._s(_vm.$t("Remove")) + "\n    ")]
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }